import { UNSTABLE_ToastQueue as ToastQueue } from "react-aria-components";
import type ToastContent from "./ToastContent.js";

export default new ToastQueue<ToastContent>();
